import { Button, Form, Layout, Select, TableColumnsType } from "antd";
import React, { useState } from "react";
import { PlusCircleOutlined } from "@ant-design/icons/lib";
import CommonTableComponent from "../common-table-component";
import { Leave_Type_Status, Week_Days } from "../../../constant/constant"
import resources from "../../../resources";
import server from "../../../server";

interface DataType {
    key: React.Key;
    day: string;
    status: string;
    auditInfo?: {
        createdOn?: string;
        createdBy?: string;
    }
}

const WorkWeek = (props: any) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const tempResources = resources.commonButtonText;
    const columns: TableColumnsType<DataType> = [
        {
            title: 'Day',
            dataIndex: 'day',
            align: "left",
        },
        {
            title: 'Status',
            dataIndex: 'status',
            align: "left",
        },
        {
            title: 'Created On',
            dataIndex: 'createdOn',
            key: 'createdOn',
            render: (value: any) => value || "-",
        },
        {
            title: 'Created By',
            dataIndex: 'createdBy',
            key: 'createdBy'
        }
    ];

    const workWeekDayOperations = () => {
        const keys = Object.keys(Week_Days) as Array<keyof typeof Week_Days>;
        const operations = keys.map((status: keyof typeof Week_Days) => {
            return {
                value: status, label: Week_Days[status]
            }
        })
        return operations;
    }

    const workWeekStatusOperations = () => {
        const keys = Object.keys(Leave_Type_Status) as Array<keyof typeof Leave_Type_Status>;
        // const keys = Object.keys(Leave_Type_Status)
        const operations = keys.map((status: keyof typeof Leave_Type_Status) => {
            return {
                value: status, label: Leave_Type_Status[status]
            }
        })
        return operations;
    }

    const propsData = {
        title: "Work Week",
        create: server.settings.workWeek.create,
        getAll: server.settings.workWeek.list,
        delete: server.settings.workWeek.delete,
        isModalOpen: isModalOpen,
        setIsModalOpen: setIsModalOpen,
        columns: columns,
        deleteById: server.settings.workWeek.delete,
        formFields: [<Form.Item
            label="Day"
            name="day"
            rules={[{required: true, message: 'Please input Day!'}]}
            initialValue={"-Select-"}>
            <Select
            >
                {workWeekDayOperations().map((operations: any) => <option key={operations.label} defaultValue={"Monday"}
                                                                          value={operations.value}>{operations.label}</option>)}
            </Select>
        </Form.Item>,
            <Form.Item
                label="Status"
                name={"status"}
                rules={[{required: true, message: 'Please input Status!'}]}
                initialValue={"-Select-"}>
                <Select>
                    {workWeekStatusOperations().map((operations: any) => <option key={operations.label}
                                                                                 value={operations.value}>{operations.label}</option>)}
                </Select>
            </Form.Item>],
        formFieldsType: [
            {name: "day", type: "payloadCode"},
            {name: "status", type: "payloadCode"},
            {name: "auditInfo.createdOn", type: "payloadCode"},
            {name: "auditInfo.createdBy", type: "payloadCode"}
        ],
        tableFieldsType: [
            {name: "day", type: "string"},
            {name: "status", type: "string"},
            {name: "createdOn", type: "date"},
            {name: "createdBy", type: "string"}
        ]
    }

    return (
        <div className="settings-section">
            <div className={'settings-section__heading'}>
                <h4>Work Week</h4>
                <Button type="primary"
                        icon={<PlusCircleOutlined/>}
                        onClick={() => setIsModalOpen(true)}
                        className="settings-section__action-button">
                    {tempResources.addButton}
                </Button>
            </div>
            <Layout className="settings-section__table-layout">
                <CommonTableComponent propsData={propsData}/>
            </Layout>
        </div>
    )
}

export default WorkWeek;
